export default __webpack_public_path__ + "static/media/suitemaster_5.21573ddb.jpg";